import axios from "axios";

const url = process.env.REACT_APP_SUPABASE_URL as string;
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY2 as string;

if (!url || !anon) {
  // Ajuda no diagnóstico em dev/build
  // Defina as envs no Vercel: REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY
  // eslint-disable-next-line no-console
  console.warn("Supabase envs ausentes.");
}

export const supabaseHttp = axios.create({
  baseURL: url ? `${url}/rest/v1` : undefined,
  headers: {
    apikey: anon ?? "",
    Authorization: `Bearer ${anon ?? ""}`, // se usar Supabase Auth, troque pelo JWT do usuário
    "Content-Type": "application/json",
  },
  // Não herda interceptors do seu client principal!
});
